import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import * as Types from '../types';
import { SimpleDialogInfoPopup } from '../SimpleDialogInfoPopup';

const popupId = uuid();

export const showSimpleDialogInfoPopupAction = ({
    message,
    actionId,
    onAccept,
    onDecline,
    acceptBtnText,
    declineBtnText
}: Omit<Types.ISimpleDialogInfoPopupParams, 'id'>) => addPopupAction({
    id: popupId,
    layer: LAYER.HIGH_PRIORITY,
    message,
    isModal: true,
    onAccept,
    onDecline,
    actionId,
    acceptBtnText,
    declineBtnText,
    component: SimpleDialogInfoPopup
});
